import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiGlobe } = FiIcons;

const Network = () => {
  return (
    <div className="pt-24 min-h-screen bg-navy text-white">
      <div className="max-w-[1200px] mx-auto px-6 py-12">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Jaringan Global & Domestik</h1>
          <p className="text-slate-400 max-w-2xl mx-auto">
            Konektivitas tanpa batas dari pelosok Nusantara hingga pusat perdagangan internasional utama di seluruh dunia.
          </p>
        </div>

        {/* Conceptual Map Area */}
        <motion.div 
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          className="relative w-full h-[500px] rounded-3xl overflow-hidden glass-panel-dark mb-16 border border-white/10 flex items-center justify-center"
        >
          {/* Using an abstract network image to represent the map elegantly */}
          <img 
            src="https://images.unsplash.com/photo-1451187580459-43490279c0fa?q=80&w=2072&auto=format&fit=crop" 
            alt="Global Network" 
            className="absolute inset-0 w-full h-full object-cover opacity-30 mix-blend-screen"
          />
          <div className="absolute inset-0 bg-navy/60 backdrop-blur-[2px]"></div>
          
          <div className="relative z-10 text-center">
             <SafeIcon icon={FiGlobe} className="text-6xl text-orange mx-auto mb-4 opacity-80" />
             <h3 className="text-2xl font-bold tracking-widest text-transparent bg-clip-text bg-gradient-to-r from-orange to-white">VISUALISASI JARINGAN AKTIF</h3>
             <p className="text-slate-300 mt-2 text-sm">Terhubung dengan 150+ Pelabuhan & Bandara Internasional</p>
          </div>

          {/* Simulated Hub Nodes */}
          <div className="absolute top-1/4 left-1/4 w-3 h-3 bg-amber rounded-full shadow-glow animate-ping"></div>
          <div className="absolute top-1/2 left-1/2 w-4 h-4 bg-orange rounded-full shadow-glow animate-pulse"></div>
          <div className="absolute bottom-1/3 right-1/4 w-3 h-3 bg-white rounded-full shadow-glow animate-ping" style={{animationDelay: '1s'}}></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
          <div className="p-6">
            <h4 className="text-4xl font-bold text-orange mb-2">34</h4>
            <p className="text-slate-400">Provinsi Terjangkau di Indonesia</p>
          </div>
          <div className="p-6 border-y md:border-y-0 md:border-x border-white/10">
            <h4 className="text-4xl font-bold text-orange mb-2">50+</h4>
            <p className="text-slate-400">Mitra Internasional</p>
          </div>
          <div className="p-6">
            <h4 className="text-4xl font-bold text-orange mb-2">24/7</h4>
            <p className="text-slate-400">Pemantauan Control Tower</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Network;